import React from 'react'
import { QuickassCategoryPicker } from 'components/QuickAssCategoryPicker'
import { trackEvent } from '@blocket/tracking'

const trackQuickAssCategoryClick = (e, labelName) => {
  trackEvent({
    objectId: 'quick-ass-category-picker',
    objectName: labelName,
    eventCategory: 'search',
    eventLabel: labelName,
    eventAction: 'clicked on quick ass category picker',
  })
}

const QuickAssCategoryPickerWithTracking = (props) => (
  <QuickassCategoryPicker {...props} trackQuickAssCategoryClick={trackQuickAssCategoryClick} />
)

export default QuickAssCategoryPickerWithTracking
